import { styled } from "../../stitches";

const Form = styled("form", {
  width: "100%",
});

export default Form;
